import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c688d86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-box" }
const _hoisted_2 = { class: "df df-center" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", {
  class: "type-table",
  border: "1"
}, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { rowspan: "2" }, "计划半成品")
  ]),
  /*#__PURE__*/_createElementVNode("tr"),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "计划完成数量")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "实际完成数量")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "完成率")
  ])
], -1))
const _hoisted_4 = ["colspan"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_a_range_picker = _resolveComponent("a-range-picker")!
  const _component_a_space = _resolveComponent("a-space")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_date_picker, {
              value: _ctx.reqPayload.produceDate,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reqPayload.produceDate) = $event)),
              placeholder: "请选择时间",
              onChange: _ctx.handleSelectDay,
              allowClear: ""
            }, null, 8, ["value", "onChange"]),
            _createVNode(_component_a_range_picker, {
              placeholder: "请选择时间段",
              value: _ctx.rangeTime,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.rangeTime) = $event)),
              style: {"width":"260px"},
              onChange: _ctx.handleSelectTime,
              allowClear: ""
            }, null, 8, ["value", "onChange"])
          ]),
          _: 1
        })
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "df row-table"
        }, [
          _hoisted_3,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row, (item, subIndex) => {
            return (_openBlock(), _createElementBlock("table", {
              key: subIndex,
              class: "rate-table",
              border: "1"
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  colspan: item.data.length
                }, _toDisplayString(_ctx.getProcessName(item.process)), 9, _hoisted_4)
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (model, modelIndex) => {
                  return (_openBlock(), _createElementBlock("th", { key: modelIndex }, _toDisplayString(model.label), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (model, modelIndex) => {
                  return (_openBlock(), _createElementBlock("td", { key: modelIndex }, _toDisplayString(model.data.planCompleted === 0
                        ? ""
                        : model.data.planCompleted), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (model, modelIndex) => {
                  return (_openBlock(), _createElementBlock("td", { key: modelIndex }, _toDisplayString(model.data.actualCompletion === 0
                        ? ""
                        : model.data.actualCompletion), 1))
                }), 128))
              ]),
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.data, (model, modelIndex) => {
                  return (_openBlock(), _createElementBlock("td", { key: modelIndex }, _toDisplayString(model.data.completionRate === 0
                        ? ""
                        : model.data.completionRate), 1))
                }), 128))
              ])
            ]))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}